export default __webpack_public_path__ + "static/media/section3-img2.80610071.png";